import React, { Fragment, useEffect, useState } from 'react';
import {
  Table,
  Spinner,
  Pagination,
  Form,
  Row,
  Col,
  Container,
  Button,
  Dropdown,
} from 'react-bootstrap';
import { FaPlus } from 'react-icons/fa';
import axios from 'axios';
import { apiUrl } from '../lib/appConfig';
import { useDebounce } from '../hooks/useDebounce';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const ServerTable = ({
  apiUrlTxt,
  columns,
  pageSize = 10,
  orderBy = 'DESC',
  customParams = {},
  showSearch = true,
  showAddBtn = true,
  showPerPage = true,
  addBtn = {},
  srlNumbr = true,
  tblLoading = false,
  customSearch = false,
  customSearchTxt = '',
}) => {
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search, 500);
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(pageSize);
  const { authToken, logout } = useAuth();

  const totalPages = Math.ceil(totalRows / limit);

  const navigate = useNavigate();

  useEffect(() => {
  if (customSearch) {
    setSearch(customSearchTxt);
    setCurrentPage(1);
  }
}, [customSearchTxt, customSearch]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const accessToken = authToken;
      const apiUrllnk = apiUrl + apiUrlTxt;

      const response = await axios.get(apiUrllnk, {
        params: {
          page: currentPage,
          limit: limit,
          order: orderBy,
          ...customParams,
          search: debouncedSearch,
        },
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const responseData = response.data;
      setData(responseData?.data || []);
      setTotalRows(responseData?.total || 0);
    } catch (error) {
      console.error('Error fetching data:', error);
      let resData = error?.response?.data;
      if((resData?.error === "Unauthorized" && resData?.message === "Invalid token") || (resData?.status === "error" && resData?.message === "Invalid or expired token")) {
          logout();
      }
      setData([]);
      setTotalRows(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, debouncedSearch, limit, JSON.stringify(customParams)]);

  const startRecord =
    totalRows === 0 ? 0 : (currentPage - 1) * limit + 1;

  const endRecord =
    totalRows === 0 ? 0 : Math.min(currentPage * limit, totalRows);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setCurrentPage(1);
  };

  const handleCreatNew = () => {
    let addBtnUrl = addBtn?.url;
    if(addBtnUrl != '') {
        navigate(addBtnUrl);
    }
  }

  return (
    <Fragment>

      {/* Header Controls */}
      {(showSearch || showAddBtn) &&
      <Row className="mb-2">
        {(showSearch) && <Col sm={6}>
          <Form.Control
            type="text"
            placeholder="Search..."
            value={search}
            onChange={handleSearchChange}
          />
        </Col>}
        {(showAddBtn) && <Col sm={6}>
          <div className="text-sm-end">
            <Button type="button" className="btn btn-primary btn-rounded waves-effect waves-light mb-2 me-2 cust-btn-rounded add-btn-sertbl" onClick={() => navigate(addBtn?.url)}>
              {(addBtn?.label == "Update Firmware")?<><i className="mdi mdi-upload me-1"></i> {addBtn?.label}</>:<><i className="mdi mdi-plus me-1"></i> {addBtn?.label}</>}
            </Button>
          </div>
        </Col>}
      </Row>}
      {/* do due left side menu issue so put position-relative1 */}
      <div className="position-relative1">
        <div className="table-responsive table-responsive-sm table-responsive-md custom-server-table">
          <Table className="custom-table align-middle fixed-action-fld">
            <thead>
              <tr>
                {srlNumbr && <th>S.No</th>}
                {columns.map((col) => (
                  <th key={col.key} className={(col.key === 'actions')?'actions-th':''}>
                    <span className="sortable">
                      {col.label}
                      <i className="bx bx-sort-alt-2 sort-icon"></i>
                    </span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {srlNumbr && <td>{rowIndex + 1}</td>}
                    {columns.map((col) => (
                      <td key={col.key} className={(col.key === 'actions')?'actions-td':''}>
                        {col.render ? col.render(row) : row[col.key]}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={srlNumbr ? columns.length + 1 : columns.length}
                    className="text-center py-4 no-recordsfound-td"
                  >
                    No records found
                  </td>
                </tr>
              )}
              <tr>
                <td
                  colSpan={srlNumbr ? columns.length + 1 : columns.length}
                  className="pagination-tbl-td"
                >
                  
                  <div className='pagination-tbltd-inner'>  

                      <div className='rows-recodrs-info'>
                            <small className="text-muted rowsperpage-sec">
                            Rows per page:&nbsp;
                            <Form.Select
                              size="sm"
                              value={limit}
                              onChange={e => setLimit(+e.target.value)}
                              style={{ width: "80px", display: "inline-block" }}
                            >
                              {[10, 20, 30, 40, 50].map(v => (
                                <option key={v} value={v}>{v}</option>
                              ))}
                            </Form.Select>
                          </small>
                          <small className="recordsinfo-sec">
                            {startRecord}-{endRecord} of {totalRows}
                          </small>
                      </div>
                      
                      <Pagination size="sm" className="pagination-top-div">
                        <Pagination.Prev
                          disabled={currentPage === 1}
                          onClick={() => setCurrentPage(p => p - 1)}
                        />
                        {/*[...Array(totalPages)].map((_, i) => (
                          <Pagination.Item
                            key={i}
                            active={currentPage === i + 1}
                            onClick={() => setCurrentPage(i + 1)}
                          >
                            {i + 1}
                          </Pagination.Item> 
                        ))*/}
                        <Pagination.Next
                          disabled={currentPage === totalPages}
                          onClick={() => setCurrentPage(p => p + 1)}
                        />
                      </Pagination>

                  </div>

                </td>
              </tr>
            </tbody>
            
          </Table>
        </div>


        {/* Overlay Spinner */}
        {(loading || tblLoading) && (
          <div className="table-overlay">
            <Spinner animation="border" className="table-spinner" />
          </div>
        )}
      </div>

      {/* Pagination Controls */}
      


    </Fragment>
  );
};

export default ServerTable;
